// clear-cart.js

// Kuinka kauan ostoskori säilyy (tunteina)
const cartExpirationHours = 1;

// Apufunktio: muotoile jäljellä oleva aika MM min SS s
function formatTime(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes} min ${seconds} s`;
}

// Päivittää laskurin tilan
function updateCartTimer(cart) {
  const warningEl = document.getElementById('cart-expiration-warning');
  const timerEl   = document.getElementById('cart-countdown-timer');

  if (cart.item_count > 0) {
    const prevCount = parseInt(localStorage.getItem('cartItemCount'), 10);
    if (
      !localStorage.getItem('cartSetTime') ||
      isNaN(prevCount) ||
      prevCount !== cart.item_count
    ) {
      localStorage.setItem('cartSetTime', Date.now());
      localStorage.setItem('cartItemCount', cart.item_count);
    }

    if (warningEl) warningEl.style.display = 'table';

    const startTime = parseInt(localStorage.getItem('cartSetTime'), 10);
    const expireAt  = startTime + cartExpirationHours * 60 * 60 * 1000;
    const timeLeft  = expireAt - Date.now();

    if (timerEl) timerEl.textContent = formatTime(timeLeft);

    if (timeLeft <= 0) {
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => {
          console.log('🛒 Ostoskori tyhjennetty tunnin kuluttua.');
          localStorage.removeItem('cartSetTime');
          localStorage.removeItem('cartItemCount');
          window.location.reload();
        })
        .catch(err => console.error('Virhe ostoskorin tyhjennyksessä:', err));
    }
  } else {
    if (warningEl) warningEl.style.display = 'none';
    localStorage.removeItem('cartSetTime');
    localStorage.removeItem('cartItemCount');
  }
}

// Käynnistys: hae kori kerran ja sitten joka sekunti
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(updateCartTimer)
    .catch(console.error);

  setInterval(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(updateCartTimer)
      .catch(console.error);
  }, 1000);
});
